import { AddUpdateQualificationDTO, ChildId, QualificationFormFields } from 'types';

export const parseQualificationFormFieldsIntoAddUpdateQualificationDTO: (
    qualificationData: QualificationFormFields,
    childId: ChildId,
) => AddUpdateQualificationDTO = (qualificationData, childId) => ({
    ...qualificationData,
    childId,
});
